















































































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { ObjectUtils } from '@/utils/objectUtils';
import { FormFieldValidation } from '@/mixins/formValidation';
import { LockModel, FontAwesomeIcons } from '@/types';

export default Vue.extend({
  name: 'MStoreMakeChangesLock',
  mixins: [FormFieldValidation],
  props: {
    lock: {
      type: Object as () => LockModel,
      default: () => ({})
    },
    bypassLockingOnToolkit: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hover: false,
      showChangeLog: false,
      changeReason: null
    };
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    onLockClicked(this: any) {
      if (this.noLock) {
        this.showChangeReasonModal();
        return;
      }
      if (this.isLockedByOtherSession) {
        return;
      }
      this.$emit('release-lock');
    },
    onChangeReasonModalShown(this: any) {
      this.$refs.changeReason.focus();
    },
    showChangeReasonModal(this: any) {
      this.changeReason = null;
      this.showChangeLog = true;
    },
    onCancelClicked(this: any) {
      this.showChangeLog = false;
      this.setApplicationDirty(false);
    },
    async onSubmitAsync(this: any) {
      this.showChangeLog = false;
      this.setApplicationDirty(false);
      this.$emit('change-reason-entered', this.changeReason);
    }
  },
  computed: {
    ...mapGetters('oidcStore', ['oidcUser']),
    lockIcon(this: any): string {
      if (this.isLoading) {
        return FontAwesomeIcons.Spinner;
      }
      if (this.noLock) {
        return FontAwesomeIcons.Eye;
      }
      if (this.isLockedByCurrentSession) {
        return FontAwesomeIcons.PenToSquare;
      }
      if (this.isLockedByUserOnOtherSession) {
        return FontAwesomeIcons.PenToSquare;
      }
      return FontAwesomeIcons.Eye;
    },
    lockPresent(this: any) {
      return !ObjectUtils.isNullOrEmpty(this.lock);
    },
    noLock(this: any) {
      return !this.lockPresent || (this.lockPresent && !this.lock.isLocked);
    },
    isLockedByCurrentSession(this: any) {
      return this.lockPresent && this.lock.isLockedByCurrentSessionId;
    },
    isLockedByOtherSession(this: any) {
      return this.lockPresent && this.lock.isLocked && !this.lock.isLockedByCurrentSessionId;
    },
    isLockedByUserOnOtherSession(this: any) {
      return this.isLockedByOtherSession && this.lock.lockedByUser.id === Number(this.oidcUser.id);
    },
    lockMessage(this: any): string {
      if (this.isLoading) {
        return 'Loading...';
      }
      if (this.noLock) {
        return 'You are in view mode and cannot make changes, click to change to edit mode';
      }
      if (this.isLockedByCurrentSession) {
        return 'You are in edit mode and can make changes, click to change to view mode';
      }
      if (this.isLockedByUserOnOtherSession) {
        return `You are in edit mode in a different session.
        If that session has been closed you must release the lock manually.`;
      }
      return `You are in view mode and cannot make changes.
      User '${this.lock.lockedByUser.name}' is currently making changes and only one user can be in edit mode.`;
    },
    containerCss(): string {
      return `d-flex flex-row ${this.hoveringAndNotLockedByOtherSession ? 'pointer' : ''}`;
    },
    lockIconCss(): string {
      return `text-secondary ${this.hoveringAndNotLockedByOtherSession ? 'opacity-65' : ''}`;
    },
    hoveringAndNotLockedByOtherSession(this: any) {
      return this.hover && !this.isLockedByOtherSession;
    }
  },
  created(this: any) {
    this.WARNING_ICON = FontAwesomeIcons.Warning;
  }
});
